// @core/api/endpoints/subscription/create_add_on.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AddOnResponse,
  CreateAddOnRequest,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Create addon
 * Creates a new purchasable addon module that can be added to subscriptions.
 */
export async function CreateAddOn(
  data: CreateAddOnRequest,
  options?: RequestOptions
): Promise<AddOnResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/addons`;
  const requestOptions = options;
  return client.post<AddOnResponse>(requestPath, data, requestOptions);
}
